'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAlarmOutline = function IoIosAlarmOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34 15l-4.2-4.1-0.7 0.7c2.7 2.5 4.4 6.2 4.4 10.2 0 3.4-1.2 6.5-3.3 8.9l2.8 3.5-1 0.8-2.7-3.4c-2.5 2.4-5.8 3.9-9.5 3.9-3.7 0-7-1.5-9.5-3.9l-2.8 3.4-0.9-0.8 2.8-3.5c-2.1-2.4-3.4-5.5-3.4-9 0-4 1.8-7.6 4.5-10.1l-0.7-0.7-4.2 4.1c-1-1.1-1.6-2.5-1.6-4.1 0-3.4 2.7-6.2 6.3-6.4h0.3c1.6 0 3.1 0.6 4.3 1.4l-4.3 4.1 0.9 0.9c2-1.5 4.4-2.5 7-2.8 0-0.6 0.7-1.2 1.3-1.2s1.2 0.6 1.2 1.2c2.6 0.3 5 1.3 7.1 2.8l0.8-0.9-4.2-4.1c1.2-0.8 2.7-1.4 4.2-1.4h0.4c3.5 0.2 6.3 3 6.3 6.4 0 1.6-0.7 3-1.6 4.1z m-28.3-1.9l7.1-6.9c-0.7-0.4-1.5-0.6-2.5-0.5-2.9 0.2-5.1 2.5-5.1 5.2 0 0.8 0.2 1.5 0.5 2.2z m26.6 8.5c0-6.9-5.6-12.4-12.5-12.4s-12.5 5.5-12.5 12.4 5.6 12.3 12.5 12.3 12.5-5.5 12.5-12.3z m-5.6-15.4l7.1 6.9c0.4-0.7 0.5-1.4 0.5-2.2 0-2.7-2.2-5-5.1-5.2-1-0.1-1.8 0.1-2.5 0.5z m-6.9 6.3h1.2v11.3h-8.7v-1.3h7.5v-10z' })
        )
    );
};

exports.default = IoIosAlarmOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-alarm-outline.js
// module id = 2290
// module chunks = 0